import React from "react";
import WaliPayHeader from "./WalipayHeader"; 

export const Blog: React.FC = () => {
    return (
        <> <WaliPayHeader /></>
    )
}